module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-700.dce81ef0.woff";